import { render, staticRenderFns } from "./FormSegundaVia.vue?vue&type=template&id=6f711183"
import script from "./FormSegundaVia.vue?vue&type=script&lang=js"
export * from "./FormSegundaVia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports